import React, { createContext } from 'react';
import { activityHistoryEntry } from '../types/definitions/ActivityHistoryEntry';

import { documentDefinition } from '../types/definitions/Document';

const ImageDataContext = React.createContext({
    loadedImageDetails: {} as documentDefinition,
    loadedImagePageNumber: 1,
    loadedImagePageUrl: '',
    loadedImageFromImageList: false,
    loadedImagePagesReady: 0,
    loadedImageTokenExpires: new Date(Date.now()) as Date,
    taggedPages: new Set(),
    imagesList: [] as documentDefinition[],
    activityHistory: [] as activityHistoryEntry[],
    cachedImageDetails: [] as documentDefinition[],
    setLoadedImage: (name: string, fromImageList: boolean) => {},
    clearLoadedImage: () => {},
    setLoadedImagePageNumber: (page: number) => {},
    addImagesToImagesList: (imagesToAdd: documentDefinition[]) => {},
    removeImagesFromImagesList: (imagesToRemove: documentDefinition[]) => {},
    setImagesListChecked: (isSelected: boolean, documentName: string) => {},
    setImagesListCheckedAll: (isSelected: boolean) => {},
    addImagesToActivityHistory: (imagesToAdd: documentDefinition[]) => {},
    clearActivityHistory: () => {},
    clearCache: () => {},
    loadImageDetails: async (fileName: string) => {},
    addTaggedPage: (page: number) => {},
    removeTaggedPage: (page: number) => {},
    clearTaggedPages: () => {},
});

export default ImageDataContext;
